document.addEventListener("DOMContentLoaded", () => {

    const slider = document.querySelector(".na-swiper");

    if (!slider) return;

    const wrapper = slider.querySelector(".swiper-wrapper");
    const slides = [...wrapper.querySelectorAll(".swiper-slide")];

    const prev = document.querySelector(".na-prev");
    const next = document.querySelector(".na-next");

    let index = 0;
    let autoPlay;

    function updateActive() {

        slides.forEach(slide => {

            slide.classList.remove(
                "na-active",
                "na-prev-slide",
                "na-next-slide"
            );

        });

        const active = slides[index];

        if (active) {

            active.classList.add("na-active");

        }

        const prevIndex =
            index === 0 ? slides.length - 1 : index - 1;

        const nextIndex =
            index === slides.length - 1 ? 0 : index + 1;

        slides[prevIndex].classList.add("na-prev-slide");
        slides[nextIndex].classList.add("na-next-slide");

    }

    function update() {

        const slide = slides[index];

        if (!slide) return;

        const sliderWidth = slider.offsetWidth;
        const slideWidth = slide.offsetWidth;
        const slideLeft = slide.offsetLeft;

        const translate =
            slideLeft - ((sliderWidth - slideWidth) / 2);

        wrapper.style.transform =
            `translate3d(-${translate}px,0,0)`;

        updateActive();

    }

    function nextSlide() {

        index++;

        if (index >= slides.length) {

            index = 0;

        }

        update();

    }

    function prevSlide() {

        index--;

        if (index < 0) {

            index = slides.length - 1;

        }

        update();

    }

    function startAuto() {

        clearInterval(autoPlay);

        autoPlay = setInterval(() => {

            nextSlide();

        }, 4000);

    }

    function stopAuto() {

        clearInterval(autoPlay);

    }

    if (next) {

        next.addEventListener("click", () => {

            nextSlide();

            startAuto();

        });

    }

    if (prev) {

        prev.addEventListener("click", () => {

            prevSlide();

            startAuto();

        });

    }

    let startX = 0;

    wrapper.addEventListener("touchstart", e => {

        startX = e.touches[0].clientX;

        stopAuto();

    });

    wrapper.addEventListener("touchend", e => {

        const endX = e.changedTouches[0].clientX;

        const diff = startX - endX;

        if (diff > 60) {

            nextSlide();

        } else if (diff < -60) {

            prevSlide();

        }

        startAuto();

    });

    slider.addEventListener("mouseenter", stopAuto);

    slider.addEventListener("mouseleave", startAuto);

    window.addEventListener("resize", update);

window.addEventListener("load", () => {

    setTimeout(() => {

        update();

        startAuto();

    }, 200);

});

});
